import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import fetchTopicsAndHierarchies from 'src/actions/topics/fetchTopicsAndHierarchies';
import topicsHierarchyResource from 'src/actions/topics/topicsHierarchyResource';
import topicsResource from 'src/actions/topics/topicsResource';
import { useResourceValues } from 'src/presentation/hooks/useResource';

export default function useTopics() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchTopicsAndHierarchies());

    return () => {
      dispatch(topicsResource.effects.unload());
      dispatch(topicsHierarchyResource.effects.unload());
    };
  }, [dispatch]);
  return useResourceValues(topicsResource);
}
